import type Transition from '@ember/routing/transition';
import { type Registry as Services, service } from '@ember/service';
import PermittedRoute from 'uplisting-frontend/pods/base/permitted-route';
import ActionBookingsSummaryController from 'uplisting-frontend/pods/action/bookings/summary/index/controller';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { AnalyticsEvents } from 'uplisting-frontend/services/analytics';

export default abstract class SidebarBookingsSummaryRoute extends PermittedRoute {
  @service analytics!: Services['analytics'];
  @service('repositories/booking')
  bookingRepository!: Services['repositories/booking'];

  permission = 'calendar.bookings';

  abstract parentRoute: string;

  model() {
    return this.modelFor(this.parentRoute) as ModelRegistry['booking'];
  }

  setupController(
    controller: ActionBookingsSummaryController,
    model,
    transition: Transition,
  ): void {
    super.setupController(controller, model, transition);

    Object.assign(controller, { booking: model });
  }

  afterModel(
    model: SidebarBookingsSummaryRouteModel,
    transition: Transition,
  ): void {
    super.afterModel(model, transition);

    this.analytics.trackEvent(AnalyticsEvents.viewedBookingSummary);
  }
}

export type SidebarBookingsSummaryRouteModel =
  RouteModel<SidebarBookingsSummaryRoute>;
